import styles from "./index.module.css";
import { useNavigate, useOutletContext } from "react-router-dom";

import { useState, useEffect } from "react";
import { Settings } from "SettingsDialog";

export default function Invoices() {
  const [iframeSrc, setIFrameSrc] = useState("");
  const settings = useOutletContext<Settings>();
  const navigate = useNavigate();
  useEffect(() => {
    async function load() {
      if (settings) {
        const response = await fetch(
          `${settings.environment.apiUrl}/dashboardUrl`,
          {
            method: "POST",
            body: JSON.stringify({
              customer_id: settings.customerId,
              dashboard: "invoices",
              color_overrides: Object.entries(settings.colorOverrides).map(
                ([name, value]) => ({ name, value })
              ),
              bm_group_key_overrides: JSON.parse(settings.bmGroupKeyOverrides),
              dashboard_options: settings.dashboardOptions.filter((opt) =>
                ["show_zero_usage_line_items", "hide_voided_invoices"].includes(
                  opt.key
                )
              ),
            }),
            headers: {
              Authorization: `Bearer ${settings.apiToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        const {
          data: { url },
        } = await response.json();

        const parsedUrl = new URL(url);
        const override =
          settings.dashboardsHostOverride ||
          settings.environment.dashboardsHost;
        if (override) {
          parsedUrl.host = override.host;
          parsedUrl.port = override.port;
          parsedUrl.protocol = override.protocol;
        }

        parsedUrl.searchParams.set(
          "graphqlUrl",
          settings.environment.graphqlUrl
        );
        setIFrameSrc(parsedUrl.toString());
      }
    }

    load();
  }, [settings]);

  return (
    <div className={styles.contentContainer} id="contentContainer">
      <div>
        <div className={styles.headingFont}>Billing & usage</div>
        <div className={styles.tabs}>
          <div className={styles.selectedTab}>Invoices</div>
          <div
            onClick={() => {
              navigate("/test-client/usage");
            }}
          >
            Usage
          </div>
          <div
            onClick={() => {
              navigate("/test-client/credits");
            }}
          >
            Credits
          </div>
          <div
            onClick={() => {
              navigate("/test-client/commits-and-credits");
            }}
          >
            Commits and Credits
          </div>
          <div className={`${styles.lastTab} ${styles.notAllowed}`}>Alerts</div>
        </div>
      </div>
      <div className={styles.dashboardContainer}>
        <iframe title="Invoices" id="dashboard" src={iframeSrc}></iframe>
      </div>
    </div>
  );
}
